import script from "./MessagesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import Alert from "@/components/Alert.vue";
import CustomerSmsSimulator from "@/components/customers/CustomerSmsSimulator.vue";
import MessageBar from "@/components/customers/MessageBar.vue";
import MessageStream from "@/components/customers/MessageStream.vue";
script.components = Object.assign({}, { Alert, CustomerSmsSimulator, MessageBar, MessageStream }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { Alert, CustomerSmsSimulator, MessageBar, MessageStream }, script.__o.components);}